export default {
  'general.logout': 'Logout',
  'general.sessionExpired': 'Your session has expired. Please log in again.',
  'general.error': 'Something went wrong',
  'general.reLogin': 'Please log in again.',
  'general.language': 'Language',
  'general.language.english': 'English',
  'general.language.french': 'French',
  'general.scrollToTop': 'Scroll To Top',
  'general.fillMandatory': 'Please Fill All Mandatory Values',
  'general.invalidEmail': 'Invalid Email Address',
  'searchResults.sortBy': 'Sort by',
  'searchResults.sortByNone': 'None',
  'searchResults.sortManually': 'Manually Sort Media',

  'searchResults.filter': 'Filter',
  'searchResults.filter.date': 'Date',
  'searchResults.filter.date.from': 'From',
  'searchResults.filter.date.to': 'To',
  'searchResults.filter.date.all': 'ALL',
  'searchResults.filter.applyFiltersButton': 'Apply Filters',

  'searchResults.options': 'Options',
  'searchResults.options.selection': 'Selection',
  'searchResults.options.selection.selectPage': 'Select All On Page',
  'searchResults.options.selection.selectSearch': 'Select All Results',
  'searchResults.options.selection.deselectAll': 'Deselect All',
  'searchResults.options.actions': 'Actions',
  'searchResults.options.actionsWorkspaceTitle': 'Workspace Actions',
  'searchResults.options.actions.addToWorkspace': 'Add to {workspaceName}',
  'searchResults.options.actions.addToWorkspace.default': 'workspace',
  'searchResults.options.actions.removeSelectedFromWorkspace': 'Remove Selected from Workspace',
  'searchResults.options.actions.exportAllToExcel':
    'Export {selectCount, plural, =0 {All} other {Selected}} to Excel (All Tags)',
  'searchResults.options.actions.exportTagsToExcel':
    'Export {selectCount, plural, =0 {All} other {Selected}} to Excel (Selected Tags)',
  'searchResults.options.actions.exportToPPT':
    'Export {selectCount, plural, =0 {All} other {Selected}} to PPT',
  'searchResults.options.actions.exportToZip':
    'Export {selectCount, plural, =0 {All} other {Selected}} to ZIP',
  'searchResults.options.actions.exportToPDF':
    'Export {selectCount, plural, =0 {All} other {Selected}} to PDF',
  'searchResults.options.actions.emailAll': 'Email All',
  'searchResults.options.actions.relateAllInWorkspace': 'Relate all items in Workspace',
  'searchResults.options.actions.umosExpectedError': 'Error retrieving Items data',
  'searchResults.options.actions.noUMOsSelected': 'No Items Found',
  'searchResults.options.actions.shareAsPortal': 'Share as Portal',
  'searchResults.options.actions.shareExternalPortal': 'Share as External Portal',
  'searchResults.options.actions.saveToDropbox':
    'Save {selectCount, plural, =0 {All} other {Selected}} to Dropbox',
  'searchResults.options.actions.resize':
    'Resize {selectCount, plural, =0 {All} other {Selected}}',
  'searchResults.options.actions.dropboxSaveSuccess': 'Success! Files saved to your Dropbox',
  'searchResults.options.actions.dropboxSaveError': 'An error occurred while saving your files to Dropbox',
  'searchResults.compare': 'Compare',
  'searchResults.copy': 'Copy',
  'searchResults.copy-screen_overlay__message': 'Select Destination Category',
  'searchResults.copy-screen_overlay__cancel': 'Press ESC to cancel',

  'searchResults.loadingHeader': 'Loading...',
  'searchResults.previousSearch': 'Back to:',
  'searchResults.previousSearchAdv': 'Advanced Search',
  'searchResults.objectsFoundHeader':
    '{objectsFoundCount} {objectsFoundCount, plural, one {item} other {items}} found',
  'searchResults.objectSelected':
    '{objectsSelectedCount} {objectsSelectedCount, plural, one {item} other {items}} selected',

  'categoryDialog.editHeader': 'Edit Category',
  'categoryDialog.saveButton': 'Save',
  'categoryDialog.createChildHeader': 'Add Child Category',
  'categoryDialog.createButton': 'Create',
  'categoryDialog.addHeader': 'Add Category',
  'categoryDialog.namePlaceholder': 'Enter Category Name',
  'categoryDialog.deleteCheckbox': 'Delete this category',
  'categoryDialog.deleteButton': 'Delete',
  'categoryDialog.deleteInProgress': 'Category delete in progress',
  'categoryDialog.deleteSuccess': 'Category deleted Successfully',

  'categoryMoveDialog.successMoveMessage': 'Move Successful',
  'categoryMoveDialog.InProgressMoveMessage': 'Move In Progress',
  'categoryMoveDialog.successCopyMessage': 'Copy Successful',
  'categoryMoveDialog.InProgressCopyMessage': 'Copy In Progress',
  'categoryMoveDialog.moveHeader': 'Move Category',
  'categoryMoveDialog.moveSubtext': 'Select the new parent for "{categoryName}".',
  'categoryMoveDialog.cancelButton': 'Cancel',
  'categoryMoveDialog.moveButton': 'Move',

  'messageDialog.dismissAllButton': 'Close',

  'metaAttach.attachButton': 'Attach metadata to selected items',
  'metaAttach.replaceCheckbox': 'Replace Metadata',
  'metaAttach.defaultAttachBehavior': 'Default: Append to Metadata',
  'metaAttach.attachArea': 'Or simply drop items here to attach the metadata.',
  'metaAttach.umosExpectedError': 'Expected UMOs to be found',
  'metaAttach.genericPartialError':
    'There was at least one error while performing metadata attach. Please try again.',
  'metaAttach.currentValues': 'Current Values',
  'metaAttach.editCurValues': 'Edit Meta Values',

  'navOptions.setsHeader': 'Highlights',
  'navOptions.workspaceHeader': 'Workspaces',
  'navOptions.categoryHeader': 'Categories',
  'navOptions.adminHeader': 'Admin',
  'navOptions.homeHeader': 'Home',
  'navOptions.formsHeader': 'Forms',
  'navOptions.thesaurusHeader': 'Thesaurus',

  'navAdminPanel.metaAttach': 'Metadata Attach',
  'navAdminPanel.manageUsers': 'Manage Users',
  'navAdminPanel.usersAndRoles': 'Users and Roles',
  'navAdminPanel.adminHeader': 'Admin',
  'navAdminPanel.manageCategoryRoles': 'Category Roles Manager',
  'navAdminPanel.publishBtn': 'Publish Media',
  'navAdminPanel.createRelationalBtn': 'Add New Record',

  'adminPublish.publishTitle': 'Publish Media',
  'adminPublish.publishBtn': 'START',
  'adminPublish.publishBtnTitle': 'Are You Sure You Want To Start The Synchronization Process?',
  'adminPublish.publishBtnStart': 'Initiate synchronization',
  'adminPublish.publishBtnCancel': 'Cancel',
  'adminPublish.publishProc.Success': 'Synchronization Process Successfully Started',
  'adminPublish.publishProc.Fail': 'An Error Occurred While Pushing Media To Portal',
  'adminPublish.publishProc.EmptyQueue': 'Nothing in Queue. All assets are already published',
  'adminPublish.publishSubTitle': 'This will publish all assets tagged accordingly to the portal',

  'navCategoryPanel.workspaceToCategoryError': 'You cannot move workspace items into a category',
  'navCategoryPanel.noEditRoleError': 'You do not have permission to move or copy items into this category',
  'navCategoryPanel.noMoveRoleError': 'You do not have permission to move items from the current category',
  'navCategoryPanel.categoryHeader': 'Categories',
  'navCategoryPanel.addCategoryButton': 'Add Category',
  'navCategoryPanel.menuAddChild': 'Add Child',
  'navCategoryPanel.menuUploadToChild': 'Upload',
  'navCategoryPanel.menuEditChild': 'Edit',
  'navCategoryPanel.menuMoveChild': 'Move',
  'navCategoryPanel.menuSortChild': 'Sort Items',

  'navFormsPanel.formHeader': 'Forms',

  'navWorkspacePanel.workspaceHeader': 'Workspaces',
  'navWorkspacePanel.addWorkspaceButton': 'Add Workspace',
  'navWorkspacePanel.menuAddChild': 'Add Child',
  'navWorkspacePanel.menuEditChild': 'Edit',

  'navHighlightsPanel.highlightsHeader': 'Highlights',
  'navHighlightsPanel.addSetButton': 'Add Highlights Set',
  'navHighlightsPanel.menuEditChild': 'Edit',

  'navThesaurusPanel.thesaurusHeader': 'Thesaurus',
  'navThesaurusPanel.addTermButton': 'Add Term',
  'navThesaurusPanel.menuEditChild': 'Edit',
  'navThesaurusPanel.attachSuccessful': 'Successfully Added',

  'thesaurusDialog.editHeader': 'Edit Term',
  'thesaurusDialog.saveButton': 'Save',
  'thesaurusDialog.createChildHeader': 'Add Child Term',
  'thesaurusDialog.createButton': 'Create',
  'thesaurusDialog.addHeader': 'Add Term',
  'thesaurusDialog.namePlaceholder': 'Enter Term Name',
  'thesaurusDialog.deleteCheckbox': 'Delete This Term',
  'thesaurusDialog.deleteButton': 'Delete',
  'thesaurusDialog.deleteInProgress': 'Delete In Progress',
  'thesaurusDialog.deleteSuccess': 'Term Deleted Successfully',

  'pagination.previousButton': 'Previous',
  'pagination.pageNumberOfTotal': 'of {pageTotal}', // i.e "2 of 3"
  'pagination.nextButton': 'Next',

  'panelTree.noItemsMessage': 'No items to show',

  'searchBar.defaultSearch': 'Simple search',
  'searchBar.advancedSearch': 'Advanced Search',
  'searchBar.advancedButton': 'ADVANCED',
  'searchBar.advanced.defaultCollectionLabel': 'Select Metadata Group',
  'searchBar.advanced.selectCollectionPlaceholder': 'Select Collection',
  'searchBar.advanced.collectionsRetrieveError': 'Error retrieving collections; click to retry',
  'searchBar.advanced.mediaType': 'Select Media Type',
  'searchBar.advanced.addMetatagButton': 'Add Metatag',
  'searchBar.advanced.searchButton': 'Search',
  'searchBar.advanced.clearButton': 'Clear',
  'searchBar.advancedForm.operatorAnd': 'AND',
  'searchBar.advancedForm.operatorOr': 'OR',
  'searchBar.advancedForm.operatorNot': 'NOT',
  'searchBar.advancedForm.anyMetatagOption': 'Any metatag',
  'searchBar.advancedForm.searchTermPlaceholder': 'Search term',
  'searchBar.advanced.saveSearch': 'Save Search',
  'searchBar.advanced.savedSearches': 'Saved Searches',
  'searchBar.advanced.searchNameMissing': 'Search Name Missing',
  'searchBar.advanced.searchSaveError': 'An error occurred while trying to save your search',
  'searchBar.advanced.deleteSearchButton': 'Delete {searchName}',
  'searchBar.advanced.saveSearchExists': 'Name already exists',
  'searchBar.advanced.specificCollection': 'Search Current Collection Only',

  'searchBar.simple.searchPlaceholder': 'Search',
  'searchBar.simple.typeAny': 'Any',
  'searchBar.simple.typeImage': 'Image',
  'searchBar.simple.typeVideo': 'Video',
  'searchBar.simple.typeAudio': 'Audio',
  'searchBar.simple.typeDocument': 'Document',
  'searchBar.simple.typeRecord': 'Record',

  'umoDetailView.requestUMOError': 'No UMO returned',
  'umoDetailView.primaryImageLabel': 'This is the primary image.',
  'umoDetailView.setAsPrimaryButton': 'Set this image as the primary image.',
  'umoDetailView.setAsPrimaryWarningMessage': 'Are you sure you want to set this image as primary?',
  'umoDetailView.addToWorkspaceButton': 'Add to {workspaceName}',
  'umoDetailView.addToWorkspaceGenericButton': 'Add to Workspace',
  'umoDetailView.DownloadImageButton': 'Download',
  'umoDetailView.DownloadViewedImageTooltip': 'Download displayed image',
  'umoDetailView.metadataHeader': 'Metadata',
  'umoDetailView.relatedItemHeader': 'Related Items:',

  'umoCardView.save': 'Save',
  'umoCardView.dueDate': 'Due Date',
  'umoCardView.status': 'Status',
  'umoCardView.delete': 'Delete',
  'umoCardView.deleteCard': 'Delete Card',
  'umoCardView.newComment': 'New',
  'umoCardView.edit': 'Edit',
  'umoCardView.edited': '(Edited)',
  'umoCardView.cancel': 'Cancel',
  'umoCardView.attachments': 'Attachments',
  'umoCardView.uploading': 'Uploading in Progress',
  'umoCardView.comments': 'Comments',
  'umoCardView.description': 'Description',
  'umoCardView.addComment': 'Add a new comment',
  'umoCardView.noAttachments': 'Nothing is attached yet',
  'umoCardView.submit': 'Submit',
  'umoCardView.commentBy': 'Comment By {name},  ',
  'umoCardView.getCardError': 'An error occurred while getting card data',
  'umoCardView.delCommentError': 'An error occurred while trying to delete the comment',
  'umoCardView.delAttachmentError': 'An error occurred while trying to delete the file',
  'umoCardView.delCardError': 'An error occurred while trying to delete the card',
  'umoCardView.delCardVerify': 'Are you sure you want to delete this card?',
  'umoCardView.delCommentUndo': 'Undo delete comment',
  'umoCardView.delFileUndo': 'Undo delete file',
  'umoCardView.undo': 'Undo',
  'umoCardView.uploadFileError': 'An error occurred while trying to upload the file',
  'umoCardView.addCommentError': 'An error occurred while trying to save the comment',
  'umoCardView.inCategory': 'In {catName}',
  'umoCardView.tabGeneral': 'General',
  'umoCardView.tabComments': 'Comments',
  'umoCardView.tabMetadata': 'Metadata',
  'umoCardView.updateCardError': 'An error occurred while updating the card',
  'umoCardView.tabHistory': 'History',
  'umoCardView.historyID': 'ID',
  'umoCardView.historyName': 'Name',
  'umoCardView.historyDetails': 'Details',
  'umoCardView.historyDate': 'Date',
  'umoCardView.historyNone': 'No history on asset',

  'umoGridItem.relatedItemTagLabel': 'Related Items',
  'umoGridItem.relatedItemTagDescription': 'Peer related Items',
  'umoGridItem.alternateItemTagLabel': 'Alternates',
  'umoGridItem.alternateItemTagDescription': 'Alternative images for primary',
  'umoGridItem.addToWorkspaceTooltip': 'Add to "{workspaceName}"',
  'umoGridItem.selectWorkspaceTooltip': 'No workspace is selected',
  'umoGridItem.reportImageTooltip': 'Report Media',
  'umoGridItem.viewDetailsButton': 'View Details',
  'umoGridItem.menuEditMetaData': 'Edit Metadata',
  'umoGridItem.menuCrop': 'Crop',
  'umoGridItem.menuImageAnnotator': 'Image Annotator',
  'umoGridItem.menuResize': 'Resize',
  'umoGridItem.menuVideoAnnotator': 'Video Annotator',
  'umoGridItem.menuVideoSnippet': 'Video Snippet',
  'umoGridItem.menuViewPeers': 'View Peers',
  'umoGridItem.menuEditMeta': 'Edit Metadata',
  'umoGridItem.menuNoDownloadsAvailableMessage': 'No downloads available',
  'umoGridItem.toolsHeader': 'Tools',
  'umoGridItem.menuDownloadsHeader': 'Downloads',
  'umoGridItem.menuRelatedImagesHeader': 'Related Images',

  'umoListItem.fileName': 'File Name',
  'umoListItem.type': 'Type',
  'umoListItem.size': 'Size',
  'umoListItem.height': 'Height (px)',
  'umoListItem.width': 'Width (px)',
  'umoListItem.duration': 'Duration',
  'umoListItem.dateCreated': 'Date Created',

  'workspace.dropRestrictionError':
    'You cannot move items between workspaces. Only from a category to a workspace, or to a different directory within the same workspace',

  'workspaceDialog.editWorkspaceHeader': 'Edit Workspace',
  'workspaceDialog.attachments': 'Attachments',
  'workspaceDialog.saveButton': 'Save',
  'workspaceDialog.addChildWorkspaceHeader': 'Add Child Workspace',
  'workspaceDialog.createButton': 'Create',
  'workspaceDialog.addWorkspaceHeader': 'Add Workspace',
  'workspaceDialog.shareLabel': 'Share',
  'workspaceDialog.sharePlaceholder': 'Select users to share your workspace with',
  'workspaceDialog.shareRemoveAll': 'Remove all',
  'workspaceDialog.nameLabel': 'Name',
  'workspaceDialog.namePlaceholder': 'Enter Workspace Name',
  'workspaceDialog.descriptionLabel': 'Description',
  'workspaceDialog.descriptionPlaceholder': 'Enter Workspace Description',
  'workspaceDialog.deleteButton': 'Delete',
  'workspaceDialog.cancelButton': 'Cancel',
  'workspaceDialog.deleteWorkspace':
    'Deleting this workspace will delete all sub workspaces as well.  This process may take a few moments to complete.',
  'workspaceDialog.deleteSuccess': 'Workspace deleted Successfully',
  'workspaceDialog.nameExists': 'A Workspace with the same name already exists',
  'workspaceDialog.errorOccurred': 'An Error has occurred while saving your workspace',

  'mainDialog.title': 'Share Links',
  'mainDialog.subTitle': 'Share media item {umoName}',
  'mainDialog.copy': 'Copied!',
  'mainDialog.copyTooltip': 'Copy to Clipboard',

  'highlightSetDialog.editWorkspaceHeader': 'Edit Highlights Set',
  'highlightSetDialog.saveButton': 'Save',
  'highlightSetDialog.createButton': 'Create',
  'highlightSetDialog.addWorkspaceHeader': 'Add Highlights Set',
  'highlightSetDialog.nameLabel': 'Name',
  'highlightSetDialog.namePlaceholder': 'Enter Set Name',
  'highlightSetDialog.descriptionLabel': 'Description',
  'highlightSetDialog.descriptionPlaceholder': 'Enter Description',
  'highlightSetDialog.deleteButton': 'Delete',
  'highlightSetDialog.cancelButton': 'Cancel',
  'highlightSetDialog.deleteWorkspace':
    'This process may take a few moments to complete.',
  'highlightSetDialog.deleteSuccess': 'Set deleted Successfully',
  'highlightSetDialog.nameExists': 'A Set with the same name already exists',
  'highlightSetDialog.errorOccurred': 'An Error has occurred while saving your set',

  'workspaceEmailDialog.emailSentSuccessMessage': 'Email successfully sent',
  'workspaceEmailDialog.emailWorkspaceHeader': 'Email Workspace',
  'workspaceEmailDialog.emailWorkspaceSubtext': 'Use this form to email the contents of this workspace.',
  'workspaceEmailDialog.emailWorkspacePortal': 'Use this form to create a temporary account with access to this workspace.',
  'workspaceEmailDialog.namePlaceholder': 'Your Name',
  'workspaceEmailDialog.accountNamePlaceholder': 'Account Name',
  'workspaceEmailDialog.toEmailPlaceholder': 'To Email Address',
  'workspaceEmailDialog.toEmailSubtext': 'Use a comma or semi-colon to separate multiple emails.',
  'workspaceEmailDialog.messagePlaceholder': 'Message',
  'workspaceEmailDialog.cancelButton': 'Cancel',
  'workspaceEmailDialog.sendButton': 'Send',
  'workspaceEmailDialog.DMZMessage': 'It might take a few minutes for all items to appear in the DMZ workspace',

  'workspaceResizeDialog.mainTitle': 'Resize Images',
  'workspaceResizeDialog.optionsTitle': 'Resize Options',
  'workspaceResizeDialog.optionsType': 'Type',
  'workspaceResizeDialog.optionsWidth': 'Width',
  'workspaceResizeDialog.optionsDPI': 'DPI',
  'workspaceResizeDialog.optionsQuality': 'Quality',
  'workspaceResizeDialog.optionsEmbedMetadata': 'Embed XMP Metadata',
  'umoModifyDialog.buttonCancel': 'Cancel',
  'umoModifyDialog.buttonApply': 'Apply',
  'umoModifyDialog.tabResize': 'Resize',
  'umoModifyDialog.tabCrop': 'Crop',
  'umoModifyDialog.tabCopy': 'Copy',
  'umoModifyDialog.tabRotate': 'Rotate',
  'umoModifyDialog.inProgressMessage': 'This process may take some time and will continue in the background',
  'workspaceDownloadDialog.buttonDownload': 'Download',
  'workspaceDownloadDialog.emailDownload': 'This item will be sent to the email address you have provided',
  'workspaceDownloadDialog.emailDynamicDownload': 'This item is dynamically generated and will be sent to the email address you provide',
  'workspaceDownloadDialog.mainTitle': 'Download Media',
  'workspaceDownloadDialog.optionsTitle': 'Download the contents of the workspace to a zip file',
  'workspaceDownloadDialog.pdfDownloadTitle': 'Generate a PDF with the contents of the workspace',
  'workspaceDownloadDialog.optionsSubTitle': 'Select the derivative for each type of media',
  'workspaceDownloadDialog.optionsPhoto': 'Photo',
  'workspaceDownloadDialog.optionsVideo': 'Video',
  'workspaceDownloadDialog.optionsAudio': 'Audio',
  'workspaceDownloadDialog.optionsDocuments': 'Documents',
  'workspaceDownloadDialog.optionsItemsPerPage': 'Select number of items per page.',

  'workspacePreview.workspaceDetailsButton': 'Workspace Details',
  'workspacePreview.options': 'Options',
  'workspacePreview.selection': 'Selection',
  'workspacePreview.selection.selectAll': 'Select All',
  'workspacePreview.selection.deselectAll': 'Deselect All',
  'workspacePreview.actions': 'Actions',
  'workspacePreview.actions.removeSelectedFromWorkspace': 'Remove Selected from Workspace',

  'utils.piction.moveCategoryGenericError': 'An unknown error has occurred, please try again.',
  'utils.piction.moveCategoryPermissionError': 'You do not have permissions to move items into the selected category',

  'metadataView.noMetadata': 'There is no metadata available for the selected umo',

  'newRelational.addNewRelational': 'Add New Record',
  'newRelational.configErr': 'Configuration Error.',
  'newRelational.contactAdminMsg': 'Contact your system admin to use this feature',
};



// WEBPACK FOOTER //
// ./src/translations/en.js